import { Alert, Clickable } from '@ahmdigital/ui';

import constants from '../../../../../ahm-constants';

type HeaderAlertProps = {
  alertLevel: string;
  isReferPage: boolean;
};

const HeaderAlert = ({ alertLevel, isReferPage }: HeaderAlertProps) => {
  const errorBodyText = isReferPage ? `Please log in to check your code or` : `Please check with your referrer or`;
  const alertContentByLevel = {
    danger: {
      body: (
        <>
          {errorBodyText} <Clickable to={constants.URLS.SALES.CONTACT_US}>contact us</Clickable>
        </>
      ),
      heading: 'Your referral code is no longer valid',
    },
    success: {
      body: 'Your referral code will automatically be applied if you join online',
      heading: 'Success! Your referral code is good to go',
    },
  };

  return (
    // @ts-expect-error - Automatic, Please fix when editing this file
    <Alert heading={alertContentByLevel[alertLevel].heading} level={alertLevel}>
      {/* @ts-expect-error - Automatic, Please fix when editing this file */}
      {alertContentByLevel[alertLevel].body}
    </Alert>
  );
};

export default HeaderAlert;
